import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { COMMON_DIRECTIVES } from './directive';
import { COMMON_PIPE_PROVIDERS } from './pipe';
import { COMMON_RESOLVER_PROVIDERS } from './resolver';
import { COMMON_SERVICE_PROVIDERS } from './service';
import { COMMON_COMPONENTS } from './component';
import { TranslateModule } from '@ngx-translate/core';

// export interface CustomCommonModuleConfig {
//   // loader?: Provider;
//   // parser?: Provider;
//   // missingTranslationHandler?: Provider;
//   // isolate?: boolean;
// }

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forChild()
  ],
  declarations: [
    ...COMMON_DIRECTIVES,
    ...COMMON_PIPE_PROVIDERS,
    ...COMMON_COMPONENTS,
  ],
  providers: [
    ...COMMON_SERVICE_PROVIDERS,
    ...COMMON_RESOLVER_PROVIDERS,
    ...COMMON_PIPE_PROVIDERS,
  ],
  exports: [
    ...COMMON_PIPE_PROVIDERS,
    ...COMMON_DIRECTIVES,
    ...COMMON_COMPONENTS,
  ]
})
export class CustomCommonModule {
  // public static forRoot(): ModuleWithProviders {
  //   return {
  //     ngModule: CustomCommonModule,
  //     providers: [{
  //       // singleton of shared service
  //       provide: SharedService,
  //       useFactory: (router: Router, storageService: LocalStorageService, api: ApiService) => SharedService.getInstance(router, storageService, api), deps: [Router, LocalStorageService, ApiService]
  //     }]

  //   };
  // }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/module.ts